// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Z1JJ","title":"Info_title__wo7uI","selects":"Info_selects__D3F7I","requiredAsterisk":"Info_requiredAsterisk__cWdJi"};